import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'
import styles from '../styles'

class Toolbar extends React.Component {
  render() {
    const {
      classes,
      toggle,
      translate,
      toggleFilters,
      refresh,
      restoreJob
    } = this.props

    return (
      <div>
        <Tooltip title={translate("tooltip_restore_recover_jobs")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='primary'
            fab
            mini
            onClick={() => refresh()}
          >
            <Icon>refresh</Icon>
          </Button>
        </Tooltip>
        {restoreJob && <Tooltip title={translate("restore_job")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='primary'
            fab
            mini
            onClick={() => restoreJob()}
          >
            <Icon>restore</Icon>
          </Button>
        </Tooltip>
        }
        <Tooltip title={translate("tooltip_filter")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='primary'
            fab
            mini
            onClick={() => toggleFilters()}
          >
            <Icon>filter_list</Icon>
          </Button>
        </Tooltip>
        <Tooltip title={translate("tooltip_view_columns")} disableTriggerFocus={true}>
          <Button
            className={classes.button}
            color='accent'
            fab
            mini
            onClick={() => toggle()}
          >
            <Icon>view_column</Icon>
          </Button>
        </Tooltip>
      </div>
    )
  }
}

export default withStyles(styles)(Toolbar)